export default function customSelect() {
    class CustomSelect {
        constructor(element) {
            this.select = element;
            this.selectedOption = this.select.querySelector('.selected-option');
            this.optionsList = this.select.querySelector('.options-list');
            this.options = this.optionsList.querySelectorAll('li');
            this.currentIndex = -1;

            // Add IDs to options for accessibility
            this.options.forEach((opt, i) => {
            opt.id = `${this.select.id || 'select'}-option-${i}`;
            });

            this.bindEvents();
        }

        openList() {
            this.optionsList.style.display = 'block';
            this.select.setAttribute('aria-expanded', 'true');
        }

        closeList() {
            this.optionsList.style.display = 'none';
            this.select.setAttribute('aria-expanded', 'false');
            this.select.removeAttribute('aria-activedescendant');
            this.clearFocus();
            this.currentIndex = -1;
        }

        focusOption(index) {
            this.clearFocus();
            this.currentIndex = index;
            const option = this.options[index];
            option.classList.add('focused');
            this.select.setAttribute('aria-activedescendant', option.id);
            option.focus(); // optional visual focus for screen readers
        }

        clearFocus() {
            this.options.forEach(opt => opt.classList.remove('focused'));
        }

        selectOption(index) {
            const option = this.options[index];
            if (!option) return;

            // Set aria-selected
            this.options.forEach(opt => opt.removeAttribute('aria-selected'));
            option.setAttribute('aria-selected', 'true');

            // Update visible text
            this.selectedOption.querySelector('.selected-text').textContent = option.textContent;

            // Update hidden native select
            const name = this.select.getAttribute('data-name'); // add this attr in HTML
            const hiddenSelect = document.querySelector(`select[name="${name}"]`);
            if (hiddenSelect) {
                hiddenSelect.value = option.dataset.value;
            }

            this.closeList();

            // Auto-submit form
            const form = this.select.closest('form');
            if (form) {
                form.requestSubmit();
            }
        }

        bindEvents() {
            this.select.addEventListener('click', (e) => {
            const isOpen = this.optionsList.style.display === 'block';
            const isOption = e.target.closest('li');
            if (!isOption) {
                isOpen ? this.closeList() : this.openList();
            }
            });

            this.select.addEventListener('keydown', (e) => {
            const key = e.key;

            if (key === 'ArrowDown') {
                e.preventDefault();
                if (this.optionsList.style.display !== 'block') this.openList();
                const next = (this.currentIndex + 1) % this.options.length;
                this.focusOption(next);
            } else if (key === 'ArrowUp') {
                e.preventDefault();
                if (this.optionsList.style.display !== 'block') this.openList();
                const prev = (this.currentIndex - 1 + this.options.length) % this.options.length;
                this.focusOption(prev);
            } else if (key === 'Enter') {
                e.preventDefault();
                if (this.currentIndex > -1) {
                this.selectOption(this.currentIndex);
                } else {
                this.openList();
                }
            } else if (key === 'Escape') {
                this.closeList();
            }
            });

            this.options.forEach((option, index) => {
            option.setAttribute('tabindex', '-1');
            option.addEventListener('click', (e) => {
                e.stopPropagation();
                this.selectOption(index);
            });
            });

            document.addEventListener('click', (e) => {
            if (!this.select.contains(e.target)) {
                this.closeList();
            }
            });
        }
    }

        // ✅ Initialize all selects
        document.querySelectorAll('.custom-select').forEach(select => {
        new CustomSelect(select);
        });
}